import { jwtDecode } from "jwt-decode";

export const getUserRole = () => {
    const token = localStorage.getItem("d_c_c_t"); 
   

    if (token) {
        try {
            const decodedToken = jwtDecode(token);
            return decodedToken?.groupName || null; // Return the role or null if not found
        } catch (error) {
            console.error("Failed to decode token", error);
            return null; // Handle errors and return null
        }
    }
    return null; // No token found
};